import { HttpEvent, HttpInterceptorFn, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { finalize } from 'rxjs/operators';

const inflightRequests = new Map<string, Observable<HttpEvent<unknown>>>();

const serializeHeaders = (headers: HttpHeaders): string => {
  return headers
    .keys()
    .sort()
    .map((key) => `${key}:${headers.getAll(key)?.join(',') ?? ''}`)
    .join('|');
};

const serializeBody = (body: unknown): string => {
  if (body === null || body === undefined) {
    return '';
  }

  if (typeof body === 'string') {
    return body;
  }

  if (body instanceof FormData) {
    const entries: string[] = [];
    body.forEach((value, key) => {
      entries.push(`${key}:${typeof value === 'string' ? value : '[binary]'}`);
    });
    return entries.sort().join('|');
  }

  if (body instanceof URLSearchParams) {
    return body.toString();
  }

  try {
    return JSON.stringify(body);
  } catch {
    return String(body);
  }
};

const requestKey = (req: HttpRequest<unknown>): string => {
  const headers = serializeHeaders(req.headers);
  const body = serializeBody(req.body);
  return `${req.method}|${req.urlWithParams}|${headers}|${body}`;
};

export const requestDedupInterceptor: HttpInterceptorFn = (req, next) => {
  const key = requestKey(req);
  const existing = inflightRequests.get(key);
  if (existing) {
    return existing;
  }

  const shared$ = next(req).pipe(
    finalize(() => inflightRequests.delete(key)),
    shareReplay({ bufferSize: 1, refCount: false })
  );

  inflightRequests.set(key, shared$);
  return shared$;
};
